import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Grid,
  IconButton,
  Tooltip,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  CardActions,
  TextField,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import CloseIcon from "@mui/icons-material/Close";
import { Buffer } from "buffer";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { saveAs } from "file-saver";
import ReactQuill from "react-quill";
import WestIcon from "@mui/icons-material/West";
import React, { useEffect, useRef, useState } from "react";
import "./PostJob.css";
import "./AppliedSeekers.css";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import "./AppliedSeekers.css";
import useAxios from "../../../api/useAxios";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import { useFormik } from "formik";
import DangerousIcon from "@mui/icons-material/Dangerous";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import BackHandIcon from "@mui/icons-material/BackHand";
import EventNoteSharpIcon from "@mui/icons-material/EventNoteSharp";
import AodIcon from "@mui/icons-material/Aod";
import * as Yup from "yup";
import SeekerDialog from "../../../components/admin-panel/admin-components/DialogBoxes/SeekerDialog";
import { Box, display } from "@mui/system";
import { Schedule, TextFields, Visibility as VisibilityIcon } from "@mui/icons-material";
import { use } from "i18next";
import moment from "moment";
const styles = {
  "&.MuiButton-contained": {
    backgroundColor: "#ffbe00",
    marginRight: "4px",
  },
};
const color = {
  "&.MuiButton-contained": {
    backgroundColor: "#b00020",
  },
};
function AppliedSeekers() {
  const axiosData = useAxios();
  const baseUrl = axiosData.defaults.baseURL;
  const [applyDetails, setApplyDetails] = useState([]);
  const [focusNo, setFocusNo] = useState(false);
  const [focus, setFocus] = useState(false);
  const [datas, setDatas] = useState([]);
  const [postJob, setPostJob] = useState(false);
  const [getOneSeeker, setGetOneSeeker] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [approvePopup, setApprovePopup] = useState(false);
  const [pendingMsg, setPendingMsg] = useState();
  const [afPendingMsg, setAfPendingMsg] = useState({});
  const [declineMsg, setDeclineMsg] = useState();
  const [approveMsg, setApproveMsg] = useState();
  const [afApproveMsg, setAfApproveMsg] = useState({});
  const [afDeclineMsg, setAfDeclineMsg] = useState({});
  const [afApproveDetails, setAfApproveDetails] = useState([]);
  const [afPendingDetails, setAfPendingDetails] = useState([]);
  const [afRejectedDetails, setAfRejectedDetails] = useState([]);

  // Partitioning for Kanban
  const colApplicants = datas.filter(d => !["S", "I", "A", "O", "H", "R"].includes(d.status));
  const colShortlisted = datas.filter(d => d.status === "S");
  const colInterview = datas.filter(d => d.status === "I");
  const colSelected = datas.filter(d => d.status === "A" || d.status === "O");
  const colHold = datas.filter(d => d.status === "H");
  const colRejected = datas.filter(d => d.status === "R");

  const [seekersPagination, setSeekersPagination] = useState(10);
  const [rejectedPopup, setRejectedPopup] = useState(false);
  const [activePaper, setActivePaper] = useState("applicants");
  const [offerLetter, setOfferLetter] = useState(false);
  const fileInputField = useRef(null);
  const [viewComments, setViewComments] = useState("");
  const [viewCommentsPopup, setViewCommentsPopup] = useState(false);
  const [file, setfile] = useState();
  const [holdpopup, setholdpopup] = useState(false);
  const [filterName, setFilterName] = useState({
    date: "allProfiles",
    isLoading: false,
  });
  const [pendingJob, setPendingJob] = useState(false);
  const [offerLetterErr, setOfferLetterErr] = useState("");
  const [selectProfilePopup, setSelectProfilePopup] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checkedViewed, setCheckedViewed] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [colSearches, setColSearches] = useState({ applicants: "", shortlisted: "", interview: "", selected: "", hold: "", rejected: "" });
  const [colPages, setColPages] = useState({ applicants: 20, shortlisted: 20, interview: 20, selected: 20, hold: 20, rejected: 20 });
  const COL_PAGE_SIZE = 20;
  let location = useLocation();
  let userDetails = JSON.parse(localStorage.getItem("user"));
  const MAX_FILE_SIZE = 1048576 * 10;
  const exceptThisSymbols = ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"];
  const formik = useFormik({
    initialValues: {
      notes: "",
      interviewer_name: "",
      interviewer_phone_number: "",
      interviewer_email: "",
      date: moment(),
      time: null,
    },
    validationSchema: Yup.object({
      notes: Yup.string().required("Comments must be required"),
      interviewer_name:
        activePaper !== "applicants"
          ? Yup.string()
            .max(50, "Must be 50 characters or less")
            .required("Interviewer name is required")
          : null,
      interviewer_phone_number:
        activePaper !== "applicants"
          ? Yup.string()
            .matches(/^[0-9]{10}$/, "Invalid phone number")
            .required("Interviewer phone number is required")
          : null,
      interviewer_email:
        activePaper !== "applicants"
          ? Yup.string()
            .matches(
              /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              "Invalid Email"
            )
            .required("Email is must be Required")
          : null,

      time:
        activePaper !== "applicants"
          ? Yup.date().required("Interview Time is required")
          : null,
      date:
        activePaper !== "applicants"
          ? Yup.date().required("Interview date is required")
          : null,
    }),
    onSubmit: (values) => {
      if (activePaper === "applicants") {
        approvePendingCall(afPendingDetails);
        getFilterValue("allProfiles", datas);

        formik.handleReset("");
      } else if (activePaper === "profile-shortlisted") {
        interview(afPendingDetails, values);
        formik.handleReset("");
      } else if (activePaper === "hold" || activePaper === "rejected") {
        interview(afPendingDetails, values);
        formik.handleReset("");
      }
      setSelectProfilePopup(false);
    },
  });

  const handleChange = () => {
    setOpen(!open);
  };
  const navigate = useNavigate();

  const getAppliedSeekers = async () => {
    try {
      const response = await axiosData.get(
        `jobapply/getbyjobid/${location.state.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data === "") {
        setLoading(false);
        setPostJob(true);
      } else {
        const datasset = response.data;
        setLoading(false);
        if (location.state.source_from?.includes("Database")) {
          setActivePaper("profile-shortlisted");
          const datasset2 = response.data.filter(
            (d) => d.job_title === location.state.job_title
          );
          setDatas(datasset2);
          setApplyDetails(datasset2);
          getFilterValue("profile-shortlisted", datasset2);
        } else {
          setDatas(response.data);
          setApplyDetails(response.data);
          getFilterValue("allProfiles", datasset);
        }
      }
      getFilterValue(activePaper, response.data);
    } catch (err) {
      console.log(err);
    }
  };
  const offerdPopupMethod = (data) => {
    setAfApproveDetails(data);
    setOfferLetter(true);
  };
  const approvePopupMethod = (data) => {
    setApprovePopup(true);
    setAfApproveDetails(data);
  };
  const rejectedPopupMethod = (data) => {
    setRejectedPopup(true);
    setAfRejectedDetails(data);
  };
  const holdPopupMethod = (data) => {
    setholdpopup(true);
    setAfRejectedDetails(data);
  };
  const selectProfile = (data) => {
    setSelectProfilePopup(true);
    setAfPendingDetails(data);
    pendingProfilePutcall(data);
  };
  useEffect(() => {
    if (userDetails === null || userDetails === undefined) {
      navigate(
        `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.PageNotFound}`
      );
    } else {
      getAppliedSeekers();
    }
  }, []);
  const deleteFile = () => {
    setfile("");
    fileInputField.current.value = "";
  };
  const ShortlistedProfile = async (data, resData) => {
    const id = data._id;
    const noteProfile = resData;
    var strippedHtml = noteProfile.replace(/<[^>]+>/g, "");
    try {
      await axiosData.post(
        "jobapply/email",
        {
          _id: id,
          seeker_name: data.seeker_name,
          company_name: userDetails.company_name,
          seeker_email: data.seeker_email,
          notes: strippedHtml,
          job_title: data.job_title,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
    getAppliedSeekers();
  };
  const viewProfile = async (data) => {
    try {
      if (data.status === "") {
        await axiosData.patch(
          "jobapply/updatestatus",
          {
            id: data._id,
            status: "V",
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        getAppliedSeekers();
      }
      const getOneAxios = await axiosData.get(`seekers/${data.seeker_id}`);
      const { data: seekerData } = getOneAxios;
      setGetOneSeeker(seekerData);
    } catch (err) {
      console.log(err);
    }
  };
  const approvePutCall = async (data) => {
    setAfApproveMsg({ approve_reason: approveMsg });
    const id = data._id;
    const commentsAppr = afApproveMsg;
    var strippedHtml = commentsAppr.replace(/<[^>]+>/g, "");
    setApprovePopup(false);
    try {
      const res = await axiosData.patch(
        "jobapply/updatestatus",
        {
          id: id,
          status: "A",
          seeker_name: data.seeker_name,
          company_name: userDetails.company_name,
          seeker_email: data.seeker_email,
          job_title: data.job_title,
          notes: strippedHtml,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res) {
        try {
          const response = await axiosData.get(
            `jobapply/getbyjobid/${location.state.id}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.data === "") {
            setLoading(false);
            setPostJob(true);
          } else {
            setDatas(response.data);
            setApplyDetails(response.data);
            const datasset = response.data;
            setLoading(false);
            getFilterValue("allProfiles", datasset);
          }
          getFilterValue(activePaper, response.data);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const approvePendingCall = async (data) => {
    setSelectProfilePopup(false);
    const commentsAppr = formik.values.notes;
    var strippedHtml = commentsAppr.replace(/<[^>]+>/g, "");
    const id = data._id;
    const totalData = {
      id: id,
      status: "S",
      source_from: "",
      seeker_name: data.seeker_name,
      company_name: userDetails.company_name,
      seeker_email: data.seeker_email,
      job_title: data.job_title,
      notes: strippedHtml,
    };

    try {
      await axiosData.patch("jobapply/updatestatus", totalData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (err) {
      console.log(err);
    }
    getAppliedSeekers();
    formik.handleReset();
  };
  const OfferedProfile = async (data) => {
    const id = afApproveDetails._id;

    if (!file) {
      setOfferLetterErr("Required");
    } else {
      try {
        const res = await axiosData.patch(
          "jobapply/updatestatus",
          {
            id: id,
            seeker_name: afApproveDetails.seeker_name,
            company_name: userDetails.company_name,
            seeker_email: afApproveDetails.seeker_email,
            job_title: afApproveDetails.job_title,
            status: "O",
            offerLetter: file,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setOfferLetter(false);
        if (res) {
          try {
            const response = await axiosData.get(
              `jobapply/getbyjobid/${location.state.id}`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            if (response.data === "") {
              setLoading(false);
              setPostJob(true);
            } else {
              setDatas(response.data);
              setApplyDetails(response.data);
              const datasset = response.data;
              setLoading(false);
              getFilterValue("allProfiles", datasset);
            }
            getFilterValue(activePaper, response.data);
          } catch (err) {
            console.log(err);
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  };
  const pendingProfilePutcall = (data) => {
    const id = data._id;
  };
  const rejectPutCall = async (data) => {
    setAfDeclineMsg({ decline_reason: declineMsg });
    const id = data._id;
    const commentsDec = afDeclineMsg;
    var strippedHtml = commentsDec.replace(/<[^>]+>/g, "");
    setRejectedPopup(false);
    try {
      const res = await axiosData.patch(
        "jobapply/updatestatus",
        {
          id: id,
          status: "R",
          seeker_name: data.seeker_name,
          company_name: userDetails.company_name,
          seeker_email: data.seeker_email,
          job_title: data.job_title,
          notes: strippedHtml,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res) {
        try {
          const response = await axiosData.get(
            `jobapply/getbyjobid/${location.state.id}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.data === "") {
            setLoading(false);
            setPostJob(true);
          } else {
            setDatas(response.data);
            setApplyDetails(response.data);
            const datasset = response.data;
            setLoading(false);
            getFilterValue("allProfiles", datasset);
          }
          getFilterValue(activePaper, response.data);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleDownload = (data) => {
    // Replace 'your_api_endpoint' with the actual API endpoint for file download.
    axiosData
      .get(`jobapply/offerletter/${data._id}`, {
        responseType: "blob", // This tells axios to treat the response as a binary blob
      })
      .then((response) => {
        // Create a download link and trigger the download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Replace 'file_name.extension' with the desired filename and extension for the downloaded file
        link.setAttribute("download", data.offerLetter.name);

        // Append the link to the DOM and trigger the click event
        document.body.appendChild(link);
        link.click();

        // Clean up after download
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };
  const viewOfferLetter = async (data) => {
    try {
      const response = await axiosData.get(`jobapply/offerletter/${data._id}`, {
        responseType: "arraybuffer",
      });
      const docBuffer = Buffer.from(response.data, "binary");
      const docDataUrl = new Blob([docBuffer]);
      window.open(new Blob([docBuffer]), "_blank");
    } catch (error) {
      console.error(error);
    }
  };
  const interview = async (data, values) => {
    setAfDeclineMsg({ Hold_reason: declineMsg });
    const id = data._id;
    const commentsDec = formik.values.notes;
    var strippedHtml = commentsDec.replace(/<[^>]+>/g, "");
    const interviewDateee = formik.values.date;
    const inDate = interviewDateee.format("DD/MM/YYYY");
    const interviewTime = formik.values.time;
    const inTime = interviewTime.format("hh:mm a");
    values.date = inDate;
    values.time = inTime;
    values.notes = strippedHtml;
    const datas = {
      id: id,
      status: "I",
      seeker_name: data.seeker_name,
      company_name: userDetails.company_name,
      seeker_email: data.seeker_email,
      job_title: data.job_title,
      seeker_mobile_number: data.seeker_mobile_number,
    };
    const totalData = { ...datas, ...values };

    formik.handleReset();
    setRejectedPopup(false);
    try {
      const res = await axiosData.patch("jobapply/updatestatus", totalData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res) {
        try {
          const response = await axiosData.get(
            `jobapply/getbyjobid/${location.state.id}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (response.data === "") {
            setLoading(false);
            setPostJob(true);
          } else {
            setDatas(response.data);
            setApplyDetails(response.data);
            const datasset = response.data;
            setLoading(false);
          }

          getFilterValue(activePaper, response.data);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const holdPutCall = async (data) => {
    setAfDeclineMsg({ Hold_reason: declineMsg });
    const id = data._id;
    const commentsDec = afDeclineMsg;
    var strippedHtml = commentsDec.replace(/<[^>]+>/g, "");
    setRejectedPopup(false);
    try {
      const res = await axiosData.patch(
        "jobapply/updatestatus",
        {
          id: id,
          status: "H",
          seeker_name: data.seeker_name,
          company_name: userDetails.company_name,
          seeker_email: data.seeker_email,
          job_title: data.job_title,
          notes: strippedHtml,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res) {
        try {
          const response = await axiosData.get(
            `jobapply/getbyjobid/${location.state.id}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.data === "") {
            setLoading(false);
            setPostJob(true);
          } else {
            setDatas(response.data);
            setApplyDetails(response.data);
            const datasset = response.data;
            setLoading(false);
            getFilterValue("allProfiles", datasset);
          }
          getFilterValue(activePaper, response.data);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const RejectedProfile = async (data, afDeclineMsg) => {
    const id = data._id;
    const noteProfile = afDeclineMsg;
    try {
      const res = await axiosData.post(
        "jobapply/RejectEmail",
        {
          _id: id,
          seeker_name: data.seeker_name,
          company_name: userDetails.company_name,
          seeker_email: data.seeker_email,
          notes: noteProfile,
          job_title: data.job_title,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res) {
        try {
          const response = await axiosData.get(
            `jobapply/getbyjobid/${location.state.id}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.data === "") {
            setLoading(false);
            setPostJob(true);
          } else {
            setDatas(response.data);
            setApplyDetails(response.data);
            const datasset = response.data;
            setLoading(false);
            getFilterValue("allProfiles", datasset);
          }
          getFilterValue(activePaper, response.data);
        } catch (err) {
          console.log(err);
        }
      }
      setDeclineMsg("");
    } catch (err) {
      console.log(err);
    }
  };
  const getFilterValue = (value, alldatas) => {
    if (value === "allProfiles") {
      const get = alldatas;
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "pending") {
      const get = alldatas.filter((i) => i.status === "");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "profile-shortlisted") {
      const get = alldatas.filter((i) => i.status === "S");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "interview-scheduled") {
      const get = alldatas.filter((i) => i.status === "I");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "offered") {
      const get = alldatas.filter((i) => i.status === "A" || i.status === "O");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "pending-Selected") {
      const get = alldatas.filter((i) => i.status === "A");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "rejected") {
      const get = alldatas.filter((i) => i.status === "R");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "viewed") {
      const get = alldatas.filter((i) => i.status === "V");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    } else if (value === "hold") {
      const get = alldatas.filter((i) => i.status === "H");
      if (get.length === 0) {
        setApplyDetails("");
        setPendingJob(true);
      } else {
        setApplyDetails(get.reverse());
      }
    }
  };

  const allLoadMore = () => {
    setSeekersPagination(seekersPagination + 10);
  };

  const allLoadLess = () => {
    setSeekersPagination(seekersPagination - 10);
  };
  const count = (status) => {
    const data = [];
    datas.map((element, index) => {
      if (element.status === status) {
        data.push(element);
      }
    });

    return data.length;
  };
  const countS = (status, status1) => {
    const data = [];
    datas.map((element, index) => {
      if (element.status === status || element.status === status1) {
        data.push(element);
      }
    });

    return data.length;
  };
  const renderKanbanCard = (data, statusKey) => (
    <div key={data._id} className={`kanban-card status-${statusKey}`}>
      {data.status === "V" && (
        <div className="kanban-viewed-badge">
          <VisibilityIcon sx={{ fontSize: 12 }} /> VIEWED
        </div>
      )}
      <div className="kanban-card-title">{data.seeker_name}</div>
      <div className="kanban-card-info">
        <div><EmailIcon sx={{ fontSize: 14, color: "#64748b" }} /> {data.seeker_email}</div>
        <div><PhoneIcon sx={{ fontSize: 14, color: "#64748b" }} /> {data.seeker_mobile_number}</div>
        <div><EventNoteSharpIcon sx={{ fontSize: 14, color: "#64748b" }} /> Applied: {data.apply_date}</div>
        <div className="job-title">{data.job_title}</div>
      </div>
      <div className="kanban-card-footer">
        <div className="kanban-card-avatar">{data.seeker_name.charAt(0)}</div>
        <div className="kanban-card-actions">
          <Tooltip title="View Profile"><IconButton size="small" className="kanban-card-btn btn-view" onClick={() => { viewProfile(data); handleChange(); }}><VisibilityIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>

          {statusKey === "applicants" && (
            <Tooltip title="Shortlist"><IconButton size="small" className="kanban-card-btn btn-shortlist" color="warning" onClick={() => selectProfile(data)}><EventNoteSharpIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          )}

          {statusKey === "shortlisted" && (
            <Tooltip title="Schedule Interview"><IconButton size="small" className="kanban-card-btn btn-interview" color="primary" onClick={() => selectProfile(data)}><PendingActionsIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          )}

          {(statusKey === "shortlisted" || statusKey === "interview" || statusKey === "hold") && (
            <Tooltip title="Select"><IconButton size="small" className="kanban-card-btn btn-select" color="success" onClick={() => approvePopupMethod(data)}><HowToRegIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          )}

          {(statusKey === "interview" || statusKey === "shortlisted" || statusKey === "applicants") && (
            <Tooltip title="Hold"><IconButton size="small" className="kanban-card-btn btn-hold" sx={{ color: "#f59e0b" }} onClick={() => holdPopupMethod(data)}><BackHandIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          )}

          {statusKey !== "rejected" && (
            <Tooltip title="Reject"><IconButton size="small" className="kanban-card-btn btn-reject" color="error" onClick={() => rejectedPopupMethod(data)}><DangerousIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          )}

          {(statusKey === "hold" || statusKey === "rejected") && (
            <Tooltip title="Reschedule"><IconButton size="small" className="kanban-card-btn btn-reschedule" color="primary" onClick={() => selectProfile(data)}><Schedule sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          )}

          {statusKey === "selected" && (
            <>
              {data.status === "A" ? (
                <Tooltip title="Upload Offer Letter"><IconButton size="small" className="kanban-card-btn btn-offer" color="info" onClick={() => offerdPopupMethod(data)}><AodIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
              ) : data.status === "O" ? (
                <Tooltip title="View Offer Letter"><IconButton size="small" className="kanban-card-btn btn-view-offer" sx={{ color: "#f43f5e" }} onClick={() => saveAs(`${baseUrl}/jobapply/offerletter/${data._id}`, data.offerLetter.name)}><VisibilityIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );

  const renderKanbanColumn = (label, colKey, cssClass, items, statusKey) => {
    const gs = globalSearch.trim().toLowerCase();
    const globalFiltered = gs
      ? items.filter(d =>
        (d.seeker_name || "").toLowerCase().includes(gs) ||
        (d.seeker_email || "").toLowerCase().includes(gs) ||
        (d.seeker_mobile_number || "").toString().includes(gs)
      )
      : items;
    const cs = (colSearches[colKey] || "").trim().toLowerCase();
    const filtered = cs
      ? globalFiltered.filter(d =>
        (d.seeker_name || "").toLowerCase().includes(cs) ||
        (d.seeker_email || "").toLowerCase().includes(cs) ||
        (d.seeker_mobile_number || "").toString().includes(cs)
      )
      : globalFiltered;
    const pageLimit = colPages[colKey] || COL_PAGE_SIZE;
    const visible = filtered.slice(0, pageLimit);
    const remaining = filtered.length - pageLimit;
    return (
      <div key={colKey} className={`applied-column ${cssClass} ${items.length === 0 ? "kanban-empty" : ""}`}>
        <div className="applied-column-header">
          <h3>{label} <span className="col-count-badge">{items.length}</span></h3>
          {items.length > 0 && (
            <input
              className="col-search-input"
              placeholder="Search in column..."
              value={colSearches[colKey]}
              onChange={e => setColSearches(prev => ({ ...prev, [colKey]: e.target.value }))}
            />
          )}
        </div>
        <div className="applied-column-content">
          {visible.map(data => renderKanbanCard(data, statusKey))}
          {filtered.length === 0 && items.length > 0 && (
            <div className="col-no-results">No results found</div>
          )}
          {remaining > 0 && (
            <button
              className="col-load-more-btn"
              onClick={() => setColPages(prev => ({ ...prev, [colKey]: prev[colKey] + COL_PAGE_SIZE }))}
            >
              Load More ({remaining} remaining)
            </button>
          )}
        </div>
      </div>
    );
  };

  const handleChangeNo = (e) => {
    setFocusNo(false);
    const { value } = e.target;
    if (value.length <= 10) {
      formik.handleChange(e);
    }
  };
  if (loading === false) {
    return (
      <div className="applied-seekers-wrapper">
        <div className="arrow-link">
          <div className="kanban-header">
            <div className="kanban-header-top">
              <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <Tooltip arrow onClick={() => navigate(-1)} title="Go Back">
                  <IconButton sx={{
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                    border: "1px solid #e2e8f0"
                  }}>
                    <WestIcon sx={{ color: "#6366f1" }} />
                  </IconButton>
                </Tooltip>
                <Typography id="headingSeekers">
                  {location.state.source_from?.includes("Database")
                    ? "Resume Access Queue"
                    : `${location.state.title}`}
                </Typography>
              </div>
              <div className="kanban-header-right">
                <input
                  className="kanban-global-search"
                  placeholder="🔍  Search all seekers..."
                  value={globalSearch}
                  onChange={e => {
                    setGlobalSearch(e.target.value);
                    setColPages({ applicants: 20, shortlisted: 20, interview: 20, selected: 20, hold: 20, rejected: 20 });
                  }}
                />
                {globalSearch && (
                  <button className="kanban-search-clear" onClick={() => setGlobalSearch("")}>✕ Clear</button>
                )}
              </div>
            </div>
            <div className="kanban-stats">
              <div className="kanban-stat-item"><b>{datas.length}</b> Total</div>
              <div className="kanban-stat-item stat-applicants"><b>{colApplicants.length}</b> Applicants</div>
              <div className="kanban-stat-item stat-shortlisted"><b>{colShortlisted.length}</b> Shortlisted</div>
              <div className="kanban-stat-item stat-interview"><b>{colInterview.length}</b> Interview</div>
              <div className="kanban-stat-item stat-selected"><b>{colSelected.length}</b> Selected</div>
              <div className="kanban-stat-item stat-hold"><b>{colHold.length}</b> Hold</div>
              <div className="kanban-stat-item stat-rejected"><b>{colRejected.length}</b> Rejected</div>
            </div>
          </div>

          <div className="applied-board">
            {renderKanbanColumn("Applicants", "applicants", "col-applicants", colApplicants, "applicants")}
            {renderKanbanColumn("Shortlisted", "shortlisted", "col-shortlisted", colShortlisted, "shortlisted")}
            {renderKanbanColumn("Interview", "interview", "col-interview", colInterview, "interview")}
            {renderKanbanColumn("Selected", "selected", "col-selected", colSelected, "selected")}
            {renderKanbanColumn("Hold", "hold", "col-hold", colHold, "hold")}
            {renderKanbanColumn("Rejected", "rejected", "col-rejected", colRejected, "rejected")}
          </div>


          <SeekerDialog
            open={open}
            handleChange={handleChange}
            getOne={getOneSeeker}
            setOpen={setOpen}
          />
          <Dialog
            open={postJob}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" } }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {"Information"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" sx={{ mt: 3 }}>
                {location.state.source_from?.includes("Database")
                  ? `No Seekers shortlisted from resume access!`
                  : `No One Applied for this Job Post!`}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  if (
                    location.state.source_from?.includes(
                      `Database-${location.state.id}`
                    )
                  ) {
                    navigate(
                      ROUTINGDATA.LAND +
                      ROUTINGDATA.MAIN +
                      ROUTINGDATA.EMPLOYERUPDATE,
                      {
                        state: userDetails.emailId,
                      }
                    );
                  } else {
                    navigate(
                      ROUTINGDATA.LAND +
                      ROUTINGDATA.MAIN +
                      ROUTINGDATA.POSTEDJOB,
                      {
                        state: userDetails.userId,
                      }
                    );
                  }

                  setPostJob(false);
                }}
                autoFocus
              >
                ok
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={selectProfilePopup}
            afApproveDetails={afApproveDetails}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" } }}
          >
            <form onSubmit={formik.handleSubmit}>
              <DialogTitle
                id="alert-dialog-title"
                bgcolor="rgb(16 143 178)"
                sx={{ color: "white", fontWeight: 600 }}
              >
                {"Confirmation"}
              </DialogTitle>

              <DialogContent sx={{ mt: 3 }}>
                <DialogContentText id="alert-dialog-description">
                  <Typography sx={{ mb: 2, color: "black", fontSize: "17px" }}>
                    <b>
                      {afPendingDetails.seeker_name} Selected for
                      {activePaper === "applicants"
                        ? " Shortlisted"
                        : " Interview"}
                    </b>
                  </Typography>
                  {activePaper !== "applicants" && (
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          label="Interviewer Name"
                          name="interviewer_name"
                          value={formik.values.interviewer_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                        />
                        {formik.touched.interviewer_name &&
                          formik.errors.interviewer_name ? (
                          <div style={{ color: "red" }}>
                            {formik.errors.interviewer_name}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Interviewer Email"
                          name="interviewer_email"
                          value={formik.values.interviewer_email}
                          onChange={(e) => {
                            setFocus(false);
                            formik.setFieldValue(
                              "interviewer_email",
                              e.target.value
                            );
                          }}
                          onBlurCapture={() => {
                            setFocus(true);
                          }}
                          onBlur={formik.handleBlur}
                          fullWidth
                        />
                        {formik.touched.interviewer_email &&
                          formik.errors.interviewer_email &&
                          focus ? (
                          <div style={{ color: "red" }}>
                            {formik.errors.interviewer_email}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label=" Interviewer Phone number"
                          name="interviewer_phone_number"
                          value={formik.values.interviewer_phone_number}
                          type="number"
                          onBlurCapture={() => {
                            setFocusNo(true);
                          }}
                          onKeyDown={(e) =>
                            exceptThisSymbols.includes(e.key) &&
                            e.preventDefault()
                          }
                          onChange={handleChangeNo}
                          onBlur={formik.handleBlur}
                          fullWidth
                        />
                        {formik.touched.interviewer_phone_number &&
                          formik.errors.interviewer_phone_number &&
                          focusNo ? (
                          <div style={{ color: "red" }}>
                            {formik.errors.interviewer_phone_number}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            disablePast
                            label="Interview Date"
                            name="date" // Make sure the name matches the field name in initialValues
                            format="DD/MM/YYYY"
                            value={formik.values.date}
                            onChange={(date) =>
                              formik.setFieldValue("date", date)
                            }
                            onBlur={formik.handleBlur}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  formik.touched.date &&
                                  Boolean(formik.errors.date)
                                }
                                helperText={
                                  formik.touched.date && formik.errors.date
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                        {formik.touched.date && formik.errors.date ? (
                          <div style={{ color: "red" }}>
                            {formik.errors.date}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <TimePicker
                            label="Interview Time"
                            value={formik.values.time}
                            onChange={(newValue) => {
                              formik.setFieldValue("time", newValue);
                            }}
                            onBlur={formik.handleBlur("time")}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                        {formik.touched.time && formik.errors.time && (
                          <div style={{ color: "red" }}>
                            {formik.errors.time}
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </DialogContentText>

                <Grid item xs={12} sx={{ marginTop: 1 }}>
                  <Typography>Comments:</Typography>
                  <ReactQuill
                    name="notes"
                    value={formik.values.notes}
                    onChange={(e) => {
                      formik.setFieldValue("notes", e);
                    }}
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote", "code-block"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ font: [] }],
                        [{ align: [] }],
                        ["link", "image"],
                        ["clean"],
                        [{}],
                      ],
                    }}
                    multiline
                    rows={3}
                    placeholder="Write something amazing..."
                    className="scrollable-container-postjob"
                  />
                  {formik.touched.notes && formik.errors.notes ? (
                    <div style={{ color: "red" }}>{formik.errors.notes}</div>
                  ) : null}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setSelectProfilePopup(false);
                    formik.handleReset();
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={formik.isValid && formik.dirty ? false : true}
                  type="submit"
                  // onClick={() => {
                  //   if (activePaper === "applicants") {
                  //     approvePendingCall(afPendingDetails);
                  //     getFilterValue("allProfiles", datas);
                  //     formik.handleReset("");
                  //   } else if (activePaper === "profile-shortlisted") {
                  //     interview(afPendingDetails);
                  //     getFilterValue("profile-shortlisted", datas);
                  //   } else if (
                  //     activePaper === "hold" ||
                  //     activePaper === "rejected"
                  //   ) {
                  //     interview(afPendingDetails);
                  //   }
                  //   setSelectProfilePopup(false);
                  // }}
                  autoFocus
                >
                  Confirm
                </Button>
              </DialogActions>
            </form>
          </Dialog>
          <Dialog
            open={rejectedPopup}
            afRejectedDetails={afRejectedDetails}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" }, zIndex: "99999" }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {"Information"}
            </DialogTitle>
            <DialogContent sx={{ mt: 3 }}>
              <DialogContentText id="alert-dialog-description">
                <b style={{ color: "black" }}>Are you sure want to Reject ?</b>
              </DialogContentText>
              <Grid item xs={12} sx={{ marginTop: 1 }}>
                <Typography>Comments:</Typography>
                <ReactQuill
                  defaultValue={"Reason of Rejected your Profile is "}
                  name="notes"
                  onChange={(e) => {
                    setAfDeclineMsg(e);
                  }}
                  modules={{
                    toolbar: [
                      ["bold", "italic", "underline", "strike"],
                      ["blockquote", "code-block"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ header: [1, 2, 3, 4, 5, 6, false] }],
                      [{ color: [] }, { background: [] }],
                      [{ font: [] }],
                      [{ align: [] }],
                      ["link", "image"],
                      ["clean"],
                      [{}],
                    ],
                  }}
                  multiline
                  rows={3}
                  placeholder="Write something amazing..."
                  className="scrollable-container-postjob"
                />
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setRejectedPopup(false);
                  formik.handleReset("");
                }}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  rejectPutCall(afRejectedDetails);
                  getFilterValue("allProfiles", datas);
                  setFilterName({ ...filterName, date: "allProfiles" });
                  formik.handleReset("");
                }}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={holdpopup}
            afRejectedDetails={afRejectedDetails}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" }, zIndex: "99999" }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {"Information"}
            </DialogTitle>
            <DialogContent sx={{ mt: 3 }}>
              <DialogContentText id="alert-dialog-description">
                <b style={{ color: "black" }}>Are you sure want to Hold ?</b>
              </DialogContentText>
              <Grid item xs={12} sx={{ marginTop: 1 }}>
                <Typography>Comments:</Typography>
                <ReactQuill
                  defaultValue={"Reason of hold your Profile is "}
                  name="notes"
                  onChange={(e) => {
                    setAfDeclineMsg(e);
                  }}
                  modules={{
                    toolbar: [
                      ["bold", "italic", "underline", "strike"],
                      ["blockquote", "code-block"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ header: [1, 2, 3, 4, 5, 6, false] }],
                      [{ color: [] }, { background: [] }],
                      [{ font: [] }],
                      [{ align: [] }],
                      ["link", "image"],
                      ["clean"],
                      [{}],
                    ],
                  }}
                  multiline
                  rows={3}
                  placeholder="Write something amazing..."
                  className="scrollable-container-postjob"
                />
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setholdpopup(false);
                  formik.handleReset("");
                }}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  holdPutCall(afRejectedDetails);

                  formik.handleReset("");
                  setholdpopup(false);
                }}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={approvePopup}
            afApproveDetails={afApproveDetails}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" }, zIndex: "99999" }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {"Information"}
            </DialogTitle>
            <DialogContent sx={{ mt: 3 }}>
              <DialogContentText id="alert-dialog-description">
                <b style={{ color: "black" }}>Are you sure want to Select ?</b>
              </DialogContentText>
              <Grid item xs={12} sx={{ marginTop: 1 }}>
                <Typography>Comments:</Typography>
                <ReactQuill
                  name="notes"
                  defaultValue={"Reason of selected Your profile is"}
                  onChange={(e) => {
                    setAfApproveMsg(e);
                  }}
                  modules={{
                    toolbar: [
                      ["bold", "italic", "underline", "strike"],
                      ["blockquote", "code-block"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ header: [1, 2, 3, 4, 5, 6, false] }],
                      [{ color: [] }, { background: [] }],
                      [{ font: [] }],
                      [{ align: [] }],
                      ["link", "image"],
                      ["clean"],
                      [{}],
                    ],
                  }}
                  multiline
                  rows={3}
                  placeholder="Write something amazing..."
                  className="scrollable-container-postjob"
                />
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setApprovePopup(false);
                  formik.handleReset("");
                }}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  approvePutCall(afApproveDetails);
                  getFilterValue("allProfiles", datas);

                  setFilterName({ ...filterName, date: "allProfiles" });
                  formik.handleReset("");
                }}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={pendingJob}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" } }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {"Information"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" sx={{ mt: 3 }}>
                No Seekers Available
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  if (location.state.source_from?.includes("Database")) {
                    const get = datas.filter((i) => i.status === "S");
                    if (get.length === 0) {
                      const get2 = datas.filter((i) => i.status === "I");
                      if (get2.length === 0) {
                        const get3 = datas.filter((i) => i.status === "A");
                        if (get3.length === 0) {
                          const get4 = datas.filter((i) => i.status === "H");
                          if (get4.length === 0) {
                            const get5 = datas.filter((i) => i.status === "R");
                            if (get5.length === 0) {
                              setPendingJob(false);
                              setChecked(false);
                            } else {
                              setPendingJob(false);
                              setActivePaper("rejected");
                              setFilterName({
                                ...filterName,
                                date: "rejected",
                              });
                              getFilterValue("rejected", datas);
                              setChecked(false);
                            }
                          } else {
                            setPendingJob(false);
                            setActivePaper("hold");
                            setFilterName({ ...filterName, date: "hold" });
                            getFilterValue("hold", datas);
                            setChecked(false);
                          }
                        } else {
                          setPendingJob(false);
                          setActivePaper("offered");
                          setFilterName({ ...filterName, date: "offered" });
                          getFilterValue("offered", datas);
                          setChecked(false);
                        }
                      } else {
                        setPendingJob(false);
                        setActivePaper("interview-scheduled");
                        setFilterName({
                          ...filterName,
                          date: "interview-scheduled",
                        });
                        getFilterValue("interview-scheduled", datas);
                        setChecked(false);
                      }
                    } else {
                      setPendingJob(false);
                      setActivePaper("profile-shortlisted");
                      setFilterName({
                        ...filterName,
                        date: "profile-shortlisted",
                      });
                      getFilterValue("profile-shortlisted", datas);
                      setChecked(false);
                    }
                  } else {
                    setPendingJob(false);
                    getFilterValue("allProfiles", datas);
                    setFilterName({ ...filterName, date: "allProfiles" });
                    setActivePaper("applicants");
                    setChecked(false);
                  }
                }}
              >
                ok
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={offerLetter}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "400px" }, zIndex: "99999" }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              Offer Letter
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid container>
                  {/* <Grid item xs={12} sx={{ marginTop: 2 }}>
                    <Typography>Comments:</Typography>
                    <ReactQuill
                      name="notes"
                      defaultValue={"Reason of selected Your profile is"}
                      onChange={(e) => {
                        setAfApproveMsg(e);
                      }}
                      modules={{
                        toolbar: [
                          ["bold", "italic", "underline", "strike"],
                          ["blockquote", "code-block"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          [{ header: [1, 2, 3, 4, 5, 6, false] }],
                          [{ color: [] }, { background: [] }],
                          [{ font: [] }],
                          [{ align: [] }],
                          ["link", "image"],
                          ["clean"],
                          [{}],
                        ],
                      }}
                      multiline
                      rows={3}
                      placeholder="Write something amazing..."
                      className="scrollable-container-postjob"
                    />
                  </Grid> */}
                  <Grid item xs={12} sx={{ mt: 3 }}>
                    <Typography sx={{ color: "black", fontSize: "18px" }}>
                      Upload Offer Letter
                      <input
                        type="file"
                        name="proofUpload"
                        onBlur={formik.handleBlur}
                        ref={fileInputField}
                        style={{ display: "none" }}
                        accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,"
                        onChange={(e) => {
                          if (e.target.files[0].size > MAX_FILE_SIZE) {
                            setOfferLetterErr(
                              "Offer Letter must be less than 10 MB"
                            );
                            setfile("");
                            fileInputField.current.value = "";
                          } else {
                            setOfferLetterErr("");
                            setfile(e.target.files[0]);
                          }
                        }}
                      />
                      <Tooltip title="Upload file" arrow>
                        <IconButton
                          color="primary"
                          onClick={() => {
                            fileInputField.current.click();
                          }}
                        >
                          <img
                            width="25"
                            height="25"
                            src="https://img.icons8.com/ios-filled/50/228BE6/upload-document.png"
                            alt="upload-document"
                          />
                        </IconButton>
                      </Tooltip>
                    </Typography>
                    <div style={{ color: "red" }}>{offerLetterErr}</div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {file ? (
                        <>
                          {file.name ? (
                            <>
                              <Typography sx={{ color: "green", mt: 1 }}>
                                {file.name}{" "}
                                <span
                                  style={
                                    file.name
                                      ? {
                                        color: "green",
                                        fontSize: "12px",
                                        marginBottom: "20px",
                                      }
                                      : { color: "red", fontSize: "12px" }
                                  }
                                >
                                  {file.size
                                    ? `${file / 1024}` >= 1024
                                      ? `-(${parseFloat(
                                        file.size / 1024 / 1024
                                      ).toFixed(3)}Mb)`
                                      : `-(${parseFloat(
                                        file.size / 1024
                                      ).toFixed(3)}Kb)`
                                    : null}
                                </span>
                              </Typography>
                              <IconButton aria-label="delete">
                                <CloseIcon
                                  sx={{ color: "red" }}
                                  onClick={() => {
                                    deleteFile();
                                  }}
                                />
                              </IconButton>
                            </>
                          ) : null}
                        </>
                      ) : null}
                    </div>
                    <Typography>Supported Files</Typography>
                    <Typography>.pdf/.doc/.docx/.jpg/.jpeg/.png/</Typography>
                  </Grid>
                </Grid>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOfferLetter(false);
                  setOfferLetterErr("");
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  OfferedProfile();
                }}
                autoFocus
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={viewCommentsPopup}
            viewComments={viewComments}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ "& .MuiPaper-root": { width: "500px" }, zIndex: "99999" }}
          >
            <DialogTitle
              id="alert-dialog-title"
              bgcolor="rgb(16 143 178)"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {"Comments"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" sx={{ mt: 2 }}>
                {viewComments}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setViewCommentsPopup(false);
                }}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div >
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div class="dots"></div>
      </div>
    );
  }
}

export default AppliedSeekers;
